export default __webpack_public_path__ + "9b2229f31c1c7ed5240cc5ab616e3a0e.svg";